import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

import { IFilter } from "../Table";

interface IFilterComponent {
  filter: IFilter;
  handleFilter;
  defaultFilter;
}

const TableFilter: FunctionComponent<IFilterComponent> = ({ filter, handleFilter, defaultFilter }) => {
  return (
    <div>
      <label>
        <strong>{filter.filterLabel}</strong>
      </label>
      <select
        id={filter.filterField}
        onChange={handleFilter}
      >
        {filter.filterProperties.map((item) => (
          <option
            selected={defaultFilter && item.filterDisplay.toLowerCase() == defaultFilter.toLowerCase()}
            value={item.fieldsToShow}
          >
            {item.filterDisplay}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TableFilter;
